import React from 'react';
import { Badge } from '@/components/ui/badge';
import { BarChart3 } from 'lucide-react';
import { CollapsibleSection } from './IntelligenceUIComponents';

const FactorRow = ({ name, weight, rawScore, weightedScore, description }) => (
  <div className="p-4 bg-muted/20 rounded-lg">
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-foreground">{name}</span>
        <Badge variant="outline" className="text-xs">{weight}% weight</Badge>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm text-muted-foreground">Raw: {rawScore}</span>
        <span className="text-sm font-semibold text-primary">Weighted: {weightedScore.toFixed(2)}</span>
      </div>
    </div>
    <div className="h-3 bg-muted/30 rounded-full overflow-hidden mb-2">
      <div className="h-full bg-primary rounded-full" style={{ width: `${rawScore}%` }} />
    </div>
    <p className="text-xs text-muted-foreground">{description}</p>
  </div>
);

export const BrandScoreSection = ({ data }) => {
  const bsd = data?.brandScoreDecomposition;
  if (!bsd) return null;

  const f = bsd.factors || [];
  
  return (
    <CollapsibleSection title="Brand Score Decomposition" icon={BarChart3} defaultOpen={true} badge="Weighted Analysis">
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="text-xs text-muted-foreground">OVERALL COMPOSITE SCORE</p>
          <p className="text-4xl font-bold text-primary">{bsd.overallScore}</p>
          <p className="text-sm text-muted-foreground">{bsd.benchmarkPosition}</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-muted-foreground">CALCULATED TOTAL</p>
          <p className="text-2xl font-semibold text-foreground">{bsd.calculatedTotal.toFixed(2)}</p>
        </div>
      </div>
      
      <div className="space-y-4">
        {f[0] && <FactorRow {...f[0]} />}
        {f[1] && <FactorRow {...f[1]} />}
        {f[2] && <FactorRow {...f[2]} />}
        {f[3] && <FactorRow {...f[3]} />}
        {f[4] && <FactorRow {...f[4]} />}
        {f[5] && <FactorRow {...f[5]} />}
      </div>
    </CollapsibleSection>
  );
};

export default BrandScoreSection;
